<template lang="pug">
  div
    v-btn(
      block
      color="warning"
      :loading="filterButtonLoading"
      @click="applyFilter()"
      :disabled="filterButtonLoading"
      ) {{ noiseDataLabel }}
    // v-card
    //   v-card-text
    //     v-slider(
    //       v-model="heatmapVisiblePoints"
    //       thumb-label
    //       step="1000"
    //       ticks
    //       min="1000"
    //       max="10000"
    //       :disabled="!heatmapVisible"
    //       :label="heatmapVisiblePoints.toString()"
    //     )
</template>

<script>
import { mapGetters } from "vuex";

import api from "@/store/utils/api";

export default {
  name: "MapMenuNoiseData",
  watch: {
    heatmapVisiblePoints: function(value) {
      // We want to hide and show the heatmap again.
      // Currently this is one of the ways to do it.
      // Make two mutations and use Promise() to make
      // sure that we fire the second, after the first
      // is finished.
      let myPromise = new Promise((resolve, reject) => {
        this.$store.dispatch("TOGGLE_HEATMAP");
        return resolve("Resolved!");
      });
      myPromise
        .then(
          function(success) {
            this.$store.dispatch("TOGGLE_HEATMAP");
          }.bind(this)
        )
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    ...mapGetters(["heatmapVisible", "filterButtonLoading"]),
    noiseDataLabel: function() {
      return this.$store.state.heatmapVisible
        ? "Hide noise data"
        : "Show noise data";
    },
    heatmapVisiblePoints: {
      get() {
        return this.$store.state.heatmapVisiblePoints;
      },
      set(val) {
        this.$store.dispatch("SET_HEATMAP_VISIBLE_POINTS", val);
      }
    },
    showNoiseData: {
      get() {
        return this.$store.state.showChoropleth;
      },
      set(val) {
        this.$store.dispatch("SET_CHOROPLETH_VISIBILITY", val);
      }
    }
  },
  methods: {
    toggleHeatmap: function() {
      // this.$store.dispatch("TOGGLE_HEATMAP");
      this.$store.dispatch("TOGGLE_FILTER_BUTTON");
      api.get("/api/randomPoints?size=10000").then(response => {
        this.$store
          .dispatch("SET_POINTS", response.map(Object.values))
          .then(() => {
            this.$store.dispatch("TOGGLE_HEATMAP");
          });
      });
    },
    applyFilter: function() {
      this.$store.dispatch("TOGGLE_FILTER_BUTTON");
      this.loader = this.filterButtonLoading;

      this.toggleHeatmap();
    }
  }
};</script>
